<template>
  <div class="g-update-layout g-device-update-layout">
    <!-- 标题 -->
    <div class="g-update-layout-title" v-if="AUTH_DEVICE_EDIT || AUTH_DEVICE_ADD">
      <h3>
        {{
          deviceId
            ? $t('com_sider_menu_device_edit') + ': ' + deviceInfo?.info?.name
            : $t('com_sider_menu_device_add')
        }}
      </h3>

      <div class="g-upadte-layout-btn">
        <a-button
          type="default"
          @click="
            () => {
              this.$router.go(-1);
            }
          "
        >
          {{ $t('com_btn_back') }}
        </a-button>

        <a-button
          type="primary"
          @click="handleSubmit"
          :loading="formLoading"
          v-if="!deviceErrorText"
          style="margin-left:10px;"
        >
          {{ $t('com_btn_save') }}
        </a-button>
      </div>
    </div>

    <!-- 内容 -->
    <div class="g-update-layout-content device-update-content-wrapper">
      <!-- 设备不存在，查询ID获取信息失败 -->
      <NoAuth v-if="!(AUTH_DEVICE_EDIT || AUTH_DEVICE_ADD)" />

      <div class="device-no-exist" v-else-if="deviceErrorText">
        <div>Error: {{ deviceErrorText }}</div>
      </div>

      <div v-else class="device-update-content">
        <a-form-model
          :model="form"
          :rules="rules"
          layout="inline"
          ref="formElement"
          labelAlign="right"
          :label-col="{ span: 12 }"
          :wrapper-col="{ span: 12 }"
        >
          <dl>
            <dt class="device-update-item-title">
              <span>{{ $t('device_base_model_title') }}</span>
            </dt>
            <dd
              class="device-update-item-list"
              style="display: flex;flex-direction: column;width:100%;"
            >
              <!-- model -->
              <a-form-model-item
                :label="$t('device_search_model_label')"
                prop="devModelName"
                :label-col="{ span: 10 }"
                :wrapper-col="{ span: 14 }"
              >
                <a-input
                  v-model="form.devModelName"
                  :placeholder="$t('device_form_select_model_placeholder')"
                  readOnly
                  @click="pickDeviceModel"
                >
                  <template slot="suffix">
                    <a-icon type="down" />
                  </template>
                </a-input>
              </a-form-model-item>

              <!-- 设备图片 -->
              <a-form-model-item
                :label="$t('device_form_icons')"
                prop="icons"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                style="width:100%;"
              >
                <UploadOSS
                  :value="form.icons"
                  :manuallyUpload="false"
                  @change="
                    fileList => {
                      form.icons = fileList || [];
                    }
                  "
                  :maxCount="1"
                  ref="uploadFile"
                  uploadDirInOSS="images"
                  uploadType="image"
                />
              </a-form-model-item>
            </dd>
          </dl>

          <dl class="basic">
            <dt class="device-update-item-title">
              <span>{{ $t('device_base_info_title') }}</span>
            </dt>
            <dd class="device-update-item-list">
              <!-- site -->
              <a-form-model-item
                :label="$t('device_table_belonged_site')"
                prop="stationId"
                :label-col="{ span: 10 }"
                :wrapper-col="{ span: 14 }"
              >
                <a-select
                  :getPopupContainer="triggerNode => triggerNode.parentNode"
                  v-model="form.stationId"
                  :placeholder="$t('device_search_site_placeholder2')"
                  show-search
                  allowClear
                  :filter-option="filterOption"
                >
                  <a-select-option
                    :value="site.info.stationId"
                    v-for="site in stationList"
                    :key="site.info.stationId"
                  >
                    {{ site.info.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>

              <!-- 名称 -->
              <a-form-model-item
                :label="$t('device_table_name')"
                prop="name"
                :label-col="{ span: 10 }"
                :wrapper-col="{ span: 14 }"
              >
                <a-input v-model="form.name" :placeholder="$t('device_form_name_placeholder')" />
              </a-form-model-item>

              <!-- SN -->
              <a-form-model-item
                :label="$t('device_table_sn')"
                prop="sn"
                :label-col="{ span: 10 }"
                :wrapper-col="{ span: 14 }"
              >
                <a-input v-model="form.sn" :placeholder="$t('device_form_sn_placeholder')" />
              </a-form-model-item>

              <!-- 出厂日期 -->
              <a-form-model-item
                :label="$t('device_base_info_arrival_date')"
                prop="birthDate"
                :label-col="{ span: 10 }"
                :wrapper-col="{ span: 14 }"
              >
                <a-date-picker
                  v-model="form.birthDate"
                  :placeholder="$t('device_form_arrive_date_placeholder')"
                />
              </a-form-model-item>
              <!-- 安装日期 -->
              <a-form-model-item
                :label="$t('device_table_install_date')"
                prop="instDate"
                :label-col="{ span: 10 }"
                :wrapper-col="{ span: 14 }"
              >
                <a-date-picker
                  v-model="form.instDate"
                  :placeholder="$t('device_form_install_date_placeholder')"
                />
              </a-form-model-item>

              <!-- 维护日期 -->
              <a-form-model-item
                :label="$t('device_table_maintenance_duration')"
                prop="maintenanceDay"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                style="width:100%"
                :extra="$t('device_form_maintenance_duration_unit')"
              >
                <a-input-number
                  v-model="form.maintenanceDay"
                  :placeholder="$t('device_form_maintenance_duration_placeholder')"
                  style="width: 100%;"
                />
              </a-form-model-item>

              <!-- remark -->
              <a-form-model-item
                :label="$t('com_form_remark')"
                prop="remark"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                style="width: 100%;"
              >
                <a-textarea
                  v-model="form.remark"
                  :placeholder="$t('com_form_remark_placeholder')"
                  :rows="6"
                  allowClear
                />
              </a-form-model-item>
            </dd>
          </dl>

          <dl
            class="basic basic-config"
            v-if="form.cfgItemList && form.cfgItemList.length"
            style="padding-bottom: 40px;"
          >
            <dt class="device-update-item-title">
              <span>{{ $t('device_config_title') }}</span>
            </dt>
            <dd class="config device-update-item-list">
              <ParamsItem
                :record="config"
                :itemValue.sync="config.value"
                :propName="'cfgItemList.' + index + '.value'"
                :label="config.name"
                :item="config"
                v-for="(config, index) in form.cfgItemList"
                :key="config.dictId + '_' + index"
                :label-col="{ span: 10 }"
                :wrapper-col="{ span: 14 }"
              />
            </dd>
          </dl>
        </a-form-model>
      </div>
    </div>

    <!-- SelectModel -->
    <SelectModel ref="selectModel" :callback="getDevModeId" />
  </div>
</template>
<script>
import { trim, makeTree } from '@/libs/utils';
import { validateEmptyStr } from '@/libs/validator';
import SelectModel from './components/selectModel';
import * as StationAPI from '@/api/site';
import * as ModelAPI from '@/api/system/model';
import * as API from '@/api/device';
import moment from 'moment';
import deviceAuth from '@/views/device/mixins/deviceAuth';

// mixins
import commonMixin from '@/mixins/common';
import cusomterMixin from '@/mixins/customer';

export default {
  mixins: [commonMixin, cusomterMixin, deviceAuth],
  components: {
    SelectModel,
  },
  data() {
    return {
      deviceInfo: null,
      form: {
        devModelName: undefined,
        devModelId: undefined,
        name: undefined,
        sn: undefined,
        stationId: undefined,
        birthDate: undefined,
        instDate: undefined,
        maintenanceDay: undefined,
        cfgItemList: [],
        remark: undefined,
        icons: undefined,
      },
      formLoading: false,

      rules: {
        devModelName: [
          {
            required: true,
            message: this.$t('device_form_select_model_placeholder'),
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: this.$t('device_form_name_placeholder'),
            trigger: 'change',
          },
          {
            validator: validateEmptyStr,
          },
        ],

        sn: [
          {
            required: true,
            message: this.$t('device_form_sn_placeholder'),
            trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              const regex = /^[a-zA-Z0-9_-]*$/;
              if (!value) {
                callback(new Error(this.$t('device_form_sn_placeholder')));
              } else if (!regex.test(value)) {
                callback(new Error(this.$t('device_form_sn_format_error')));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],

        stationId: [
          {
            required: true,
            message: this.$t('device_search_site_placeholder2'),
            trigger: 'change',
          },
        ],

        birthDate: [
          {
            required: true,
            message: this.$t('device_form_arrive_date_placeholder'),
            trigger: 'change',
          },
        ],

        instDate: [
          {
            required: true,
            message: this.$t('device_form_install_date_placeholder'),
            trigger: 'change',
          },
        ],
      },

      currentModel: null,
      paramsLoading: false,

      stationList: [],

      // model list
      modelList: {},

      // 设备id
      deviceId: null,
      deviceErrorText: null,
    };
  },
  created() {
    if (this.$route && this.$route.params) {
      // id
      if (this.$route.params.id) {
        this.deviceId = this.$route.params.id;
        // 获取数
        this.getDeviceDetail();
      } else {
        this.getData();
      }

      // 序列号
      if (this.$route.params.SN) {
        this.form.sn = this.$route.params.SN;
      }
    }

    // staion Id
    if (this.$route && this.$route.query && this.$route.query.siteId) {
      this.form.stationId = this.$route.query.siteId;
    }
  },
  methods: {
    // 获取表单数据
    getData() {
      const _list = [this.getModelList(), this.getAllSiteList()];

      Promise.all(_list).finally(() => {
        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
        this.loading = false;
      });
    },

    // 获取model list
    getModelList() {
      this.loading = true;
      return ModelAPI.DeviceModelListAll()
        .then(res => {
          try {
            const treeObj = makeTree({
              data: res.data || [],
              idName: 'devModelId',
              parentIdName: 'parentId',
              deleteIcon: false,
            });

            this.modelList = treeObj;

            // 获取当前model
            if (this.deviceInfo) {
              const listObject = this.modelList.object;
              this.currentModel = listObject[this.deviceInfo.info.devModelId];
              this.form.devModelName = this.currentModel.name;
            }
          } catch (err) {
            console.log('err', err);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 选择Model
    pickDeviceModel() {
      this.$refs.selectModel.show(this.modelList, this.form.devModelId);
    },

    // 获取model id
    getDevModeId(model) {
      if (model) {
        // 是不是编辑
        if (this.deviceInfo?.info.devModelId === model.devModelId) {
          this.form.cfgItemList = this.deviceInfo.cfgItems.filter(item => item.input === true);
        } else {
          // 添加
          this.getModelParams(model);
        }

        this.currentModel = model;
        this.form.devModelId = model.devModelId;
        this.form.devModelName = model.name;
      }
    },

    // 获取所有站点
    getAllSiteList() {
      const params = { pageNo: 1, pageSize: 10000 };
      return StationAPI.SiteList(params).then(res => {
        if (res.code === 0) {
          this.stationList = res.data;
        }
      });
    },

    // 获取model 配置参数
    getModelParams(model) {
      const params = {
        devModelId: model.devModelId,
      };
      this.paramsLoading = true;
      return ModelAPI.DeviceConfigList(params)
        .then(res => {
          if (res.code === 0) {
            let list = res.data || [];
            // 可输入的参数
            list = (res.data || []).filter(item => item.input === true);
            this.form.cfgItemList = [];
            list.forEach(item => {
              this.form.cfgItemList.push(item);
            });
          }
        })
        .finally(() => {
          this.paramsLoading = false;
        });
    },

    // 提交
    handleSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          const params = { ...this.form };

          // 指定字段，格式化两边的空格
          for (const item in params) {
            if (['name', 'sn', 'model', 'systemConfig'].includes(item)) {
              params[item] = trim(params[item]);
            } else if (['birthDate', 'instDate'].includes(item)) {
              params[item] = new Date(params[item]).getTime();
            }
          }

          if (params.cfgItemList && params.cfgItemList.length) {
            const _newCfgItemList = [];
            params.cfgItemList.forEach(item => {
              _newCfgItemList.push({
                dataSrc: item.dataSrc,
                value: item.value,
              });
            });
            params.cfgItemList = _newCfgItemList;
          }

          // 添加
          if (this.deviceId) {
            params.devId = this.deviceId;
            if (
              this.deviceInfo &&
              this.deviceInfo.info &&
              this.deviceInfo.info.devSn !== this.form.sn
            ) {
              const h = this.$createElement;
              this.$confirm({
                title: this.$t('device_confirm_save_title'),
                content: h('div', {}, [
                  h('p', this.$t('device_confirm_save')),
                  h('p', `SN: ${this.deviceInfo.info.devSn} -> ${this.form.sn}`),
                ]),
                centered: true,
                onOk: () => {
                  this.formLoading = true;
                  // 编辑
                  API.DeviceEdit(params)
                    .then(res => {
                      if (res.code === 0) {
                        // 保存成功返回上一页
                        this.$router.go(-1);
                      }
                    })
                    .finally(() => {
                      this.formLoading = false;
                    });
                },
              });
            } else {
              this.formLoading = true;
              // 编辑
              API.DeviceEdit(params)
                .then(res => {
                  if (res.code === 0) {
                    // 保存成功返回上一页
                    this.$router.go(-1);
                  }
                })
                .finally(() => {
                  this.formLoading = false;
                });
            }
          } else {
            // 添加
            API.DeviceAdd(params)
              .then(res => {
                if (res.code === 0) {
                  // 保存成功返回上一页
                  this.$router.go(-1);
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          }
        }
      });
    },

    // 获取设备详情
    getDeviceDetail() {
      const params = {
        devId: this.deviceId,
      };
      return API.DeviceInfo(params).then(res => {
        if (res.code === 0) {
          // 设置form
          if (res.data && res.data.info) {
            this.deviceInfo = res.data;

            Object.keys(this.form).forEach(key => {
              if (['birthDate', 'instDate'].includes(key)) {
                this.form[key] = moment(res.data.info[key]);
              } else if (['cfgItemList'].includes(key)) {
                this.form[key] = res.data.info[key] || [];
              } else if (key === 'sn') {
                this.form[key] = res.data.info['devSn'] || [];
              } else {
                this.form[key] = res.data.info[key];
              }
            });

            // 可修改配置
            this.form.cfgItemList = [];
            if (res.data.cfgItems) {
              this.form.cfgItemList = res.data.cfgItems.filter(item => item.input === true);
            }

            // 获取其他数据
            this.getData();

            // 记录当前站点路由
            // this.$store.commit('setHistoryRouteList', {
            //   ...this.$route,
            // });
          }
        } else {
          this.loading = false;
          this.$store.commit('setPageLoading', false);
          this.deviceErrorText = res.message;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.device-update-content-wrapper {
  justify-content: flex-start;
  width: 100%;
  .device-update-content {
    width: 100%;

    .device-update-item-title {
      background: url('~@/assets/img/line.png') center center repeat-x;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      color: #000;
      font-size: 18px;
      font-weight: 600;

      span {
        background: #fff;
        height: 100%;
        display: flex;
        padding-right: 12px;
      }
    }

    ::v-deep .device-update-item-list {
      max-width: 80%;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;

      .ant-form-item {
        margin: 0 0 24px 0;
        width: 50%;
      }

      // config
      .form-item-type {
        width: 50%;
        .ant-form-item {
          margin-bottom: 0;
        }
      }
    }
  }
}

::v-deep .device-form {
  dl {
    border: #eee solid 1px;
    border-radius: 5px;
    overflow: hidden;
    max-width: 1000px;
    dt {
      font-size: 16px;
      font-weight: bold;
      background: #f9f9f9;
      padding: 10px;
      width: 100%;
      border-bottom: #eee solid 1px;
    }
    dd {
      width: 100%;
      padding: 20px 0;

      &.config {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        > div {
          width: 50%;

          > span {
            position: relative;
            top: 10px;
          }
        }
      }
    }

    .device-save {
      padding-top: 30px;
      display: flex;
      justify-content: center;
      max-width: 850px;
    }

    &.basic-config {
      padding-bottom: 50px;
    }
  }
}

.device-no-exist {
  font-size: 16px;
  margin: 0 auto;
  text-align: center;
  color: #666;
  > div {
    margin-bottom: 20px;
    color: #f00;
  }
}
</style>
